import { fillzero } from './fillzero'
export const fullDate = (input) => {
  let d = new Date()
  d.setTime(input * 1000)
  return `
    ${fillzero(d.getFullYear())}-
    ${fillzero(d.getMonth() + 1)}-${fillzero(d.getDate())} 
  `
}



// WEBPACK FOOTER //
// ./src/filters/fullDate.js